var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatforms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91723 0.909465C4.96406 0.394386 5.39592 0 5.91313 0H7.0867C7.6039 0 8.03576 0.394385 8.08259 0.909464L8.27264 3L4.72718 3L4.91723 0.909465ZM4.63627 4L8.36355 4L8.909 10H4.09082L4.63627 4ZM10.9999 5H13.9999V7H10.9999V5ZM14.9999 8H9.99994V10H14.9999V8ZM15.9999 13H16.9999V11H14.9999H9.99994H4.99994H2.99994V13H3.99994V14.7374C3.41636 14.797 2.841 14.9614 2.30273 15.2306L0.552734 16.1056L1.44716 17.8944L3.19716 17.0194C4.01728 16.6094 4.98261 16.6094 5.80273 17.0194C7.18591 17.711 8.81398 17.711 10.1972 17.0194L10.4472 16.8944C11.4247 16.4057 12.5752 16.4057 13.5527 16.8944C15.0933 17.6647 16.9066 17.6647 18.4472 16.8944L19.4472 16.3944L18.5527 14.6056L17.5527 15.1056C17.064 15.3499 16.532 15.4721 15.9999 15.4721V13ZM13.9999 14.9064V13H10.9999V14.62C12.0003 14.4341 13.0404 14.5296 13.9999 14.9064ZM8.99994 15.3611V13H5.99994V14.9464C6.23748 15.0226 6.47061 15.1173 6.69716 15.2306C7.4183 15.5911 8.2517 15.6347 8.99994 15.3611Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatforms);
export default __webpack_public_path__ + "static/media/platforms.09ca66e4.svg";
export { ForwardRef as ReactComponent };